/** Cross-app protocol: embedded report UIs publish share context to Reporting Center shell. */

export const REPORT_SHARE_MESSAGE = 'REPORT_SHARE_CONTEXT';
export const REPORT_SHARE_CLEAR = 'REPORT_SHARE_CLEAR';

function isEmbeddedReportView() {
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('embedded') === 'true';
  } catch {
    return false;
  }
}

function trustedParentOrigin() {
  if (typeof window === 'undefined' || !window.parent || window.parent === window) {
    return null;
  }
  try {
    if (document.referrer) {
      const origin = new URL(document.referrer).origin;
      if (origin && origin !== 'null') return origin;
    }
  } catch {
    /* ignore */
  }
  return window.location.origin;
}

/**
 * Normalize share context from iframe or in-shell publisher.
 * @returns {object|null}
 */
export function normalizeReportShareContext(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const serviceKey = String(raw.service_key || raw.serviceKey || '').trim();
  const reportName = String(raw.report_name || raw.reportName || '').trim();
  if (!serviceKey || !reportName) return null;
  const metrics = Array.isArray(raw.metrics)
    ? raw.metrics
        .filter((m) => m && m.label)
        .slice(0, 50)
        .map((m) => ({ label: String(m.label), value: String(m.value ?? '—') }))
    : [];
  return {
    service_key: serviceKey,
    report_name: reportName,
    report_period: raw.report_period || raw.reportPeriod || null,
    report_url: raw.report_url || raw.reportUrl || null,
    executive_report_id: raw.executive_report_id || raw.executiveReportId || null,
    metrics,
    ready: raw.ready !== false,
  };
}

/** Embedded micro-apps call this when report preview/summary is available. */
export function publishReportShareContextToParent(context) {
  if (!isEmbeddedReportView()) return;
  const normalized = normalizeReportShareContext(context);
  if (!normalized) return;
  const target = trustedParentOrigin();
  if (!target || !window.parent || window.parent === window) return;
  window.parent.postMessage({ type: REPORT_SHARE_MESSAGE, context: normalized }, target);
}

export function clearReportShareContextFromParent() {
  if (!isEmbeddedReportView()) return;
  const target = trustedParentOrigin();
  if (!target || !window.parent || window.parent === window) return;
  window.parent.postMessage({ type: REPORT_SHARE_CLEAR }, target);
}

export function isReportShareMessage(event) {
  if (!event?.data || typeof event.data !== 'object') return false;
  return event.data.type === REPORT_SHARE_MESSAGE || event.data.type === REPORT_SHARE_CLEAR;
}
